<!--
Displays a wait/loading spinner.
Usage:
  HTML:
    <Spinner ref="spinner" />
  JavaScript:
    this.$refs.spinner.spin()
    this.$refs.spinner.stop()
@author bmk11u
-->
<template>
  <div style="display:inline-block;margin-right:24px;float:right;" @change="saveSetting">
    <label class="switch">
      <input type="checkbox" :checked="toggled">
      <span class="slider round"></span>
    </label>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'ToggleButton',
  props: ['name', 'toggle'],
  methods: {
    saveSetting () {
      var newVal = ''
      this.toggled = !this.toggled
      console.log('Toggle is')
      console.log(this.toggled)
      if (this.toggled) {
        newVal = 'Y'
      } else {
        newVal = 'N'
      }
      axios.post('/timetable/settings', {}, {
        params: {
          settingName: this.name,
          settingValue: newVal
        }
      }).then(response => {
        console.log(response)
      })
    }
  },
  data () {
    return {
      show: false,
      toggled: this.toggle
    }
  },
  mounted () {
    console.log(this.toggled)
  }
}
</script>

<style scoped lang="scss">
/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 30px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 24px;
  width: 24px;
  left: 2px;
  bottom: 3px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #951272;
}

input:focus + .slider {
  box-shadow: 0 0 1px #951272;
}

input:checked + .slider:before {
  -webkit-transform: translateX(22px);
  -ms-transform: translateX(22px);
  transform: translateX(22px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>
